namespace RedBullMOBILE360.Administration {
    export interface RolePermissionListResponse extends Serenity.ListResponse<string> {
    }
}

